import React, { HTMLAttributes, MouseEventHandler, useCallback } from 'react';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';

import Button from 'components/UI/Buttons/Button/Button';

import styles from './ModalHeader.module.scss';

type BaseProps = React.PropsWithChildren<
  HTMLAttributes<HTMLDivElement> & {
    CloseComponent?: React.ReactElement | false;
  }
>;

type PropsWithCloseComponentProps = BaseProps & {
  CloseComponent: React.ReactElement | false;
  onClose?: MouseEventHandler;
  classes?: undefined;
};

type PropsWithoutCloseComponentProps = BaseProps & {
  CloseComponent?: undefined;
  onClose: MouseEventHandler;
  classes?: { closeElement?: CloseComponentNodeProps['classes'] };
};

type Props = PropsWithCloseComponentProps | PropsWithoutCloseComponentProps;

export default function ModalHeader({
  children,
  CloseComponent,
  onClose,
  className,
  classes,
  ...props
}: Props): JSX.Element {
  const CloseComp = useCallback((): JSX.Element => {
    if (false === CloseComponent) {
      return <></>;
    }

    if (CloseComponent) {
      return CloseComponent;
    }

    return (
      <CloseComponentNode onClose={onClose} classes={classes?.closeElement} />
    );
  }, [CloseComponent, onClose]);

  return (
    <div className={classNames(styles.header, className)} {...props}>
      {children}
      <CloseComp />
    </div>
  );
}

type CloseComponentNodeProps = {
  onClose: Props['onClose'];
  classes?: { closeWrapper?: string; closeButton?: string };
};

function CloseComponentNode({
  onClose,
  classes,
}: CloseComponentNodeProps): JSX.Element {
  return (
    <div className={classNames(styles.closeWrapper, classes?.closeWrapper)}>
      <Button
        className={classNames(styles.closeButton, classes?.closeButton)}
        onClick={onClose}
      >
        <CloseIcon fontSize={'inherit'} />
      </Button>
    </div>
  );
}
